module.exports = __webpack_public_path__ + "static/media/lid-margin.6095bb5f.png";